const shouldGetCategory = isNewPage => isNewPage || SERVER;

export default shouldGetCategory;
